export default "__VITE_ASSET__Cnb7qlSj__"